import * as React from 'react';
import { FormControl, OutlinedInput } from '@mui/material';
import styled from 'styled-components';
import { ProtrakLabel } from './ProtrakLabel';

const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  padding: 0,
  '.MuiInputBase-input.Mui-disabled': {
    background: theme.palette.disabled.light
  }
}));

export const FormInput = ({
  placeholder,
  value = '',
  type,
  style,
  minRows,
  maxRows,
  rows,
  endAdornment,
  onChange,
  isError = false,
  errorMessage = '',
  isRequired = false,
  isMultiline = false,
  isDisabled = false,
  errorMessageStyle = {},
  conatinerStyle = {}
}) => {
  return (
    <FormControl error variant="outlined" sx={conatinerStyle}>
      <StyledInput
        type={type}
        placeholder={placeholder}
        minRows={minRows}
        maxRows={maxRows}
        rows={rows}
        sx={{
          ...style,
          '& fieldset': {
            border: '1px solid #E5E5E5 !important',
            borderRadius: '3px'
          }
        }}
        endAdornment={endAdornment}
        disabled={isDisabled}
        required={isRequired}
        multiline={isMultiline}
        onChange={event => onChange(event.target.value)}
        value={value}
        error={isError}
      />

      <ProtrakLabel
        text={errorMessage}
        style={{ margin: 0, minHeight: '1rem', ...errorMessageStyle }}
      />
    </FormControl>
  );
};
